<script>
	import {cn} from "$lib/utils.js";
	import Cell from "./bits/calendar-cell.svelte";

	let {ref = $bindable(null), class: className, ...restProps} = $props();
</script>

<Cell
  bind:ref
  class={cn(
		//"[&:has([data-selected])]:bg-accent [&:has([data-selected][data-outside-month])]:bg-accent/50 relative size-9 p-0 text-center text-sm focus-within:relative focus-within:z-20 [&:has([data-selected])]:rounded-md",
		"[&:has([data-selected])]:bg-accent [&:has([data-selected][data-outside-month])]:bg-accent/50 relative p-0 text-center text-sm focus-within:relative focus-within:z-20 [&:has([data-selected])]:rounded-md",
		className
	)}
  {...restProps}
/>
